import React from 'react';
import {AdvisorSolutionsFooter} from "../../pages/sign-in/components/AdvisorSolutionsFooter";
import {CustodySolutionsFooter} from "../../pages/sign-in/components/CustodySolutionsFooter";

export function Footer() {
    const domain = window.location.hostname;
    const isAdvisorSite = domain.includes('advisorsolutions');

    if(isAdvisorSite) return <AdvisorSolutionsFooter/>
    return <CustodySolutionsFooter/>
}

